import { BaseAudioRecordingAppEventOperation } from "./BaseAudioRecordingAppEventOperation";
import { AudioRecordingAppEventOperationKind } from "@/store/sync/operations/types";

export class MarkPausedLocalAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind(): AudioRecordingAppEventOperationKind {
    return "MARK_PAUSED_LOCAL_AUDIO_RECORDING";
  }

  // Pause doesn't change recording_status - it's still IN_PROGRESS
  // The event is tracked for observability purposes
}
